// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import StepProgressBar from 'shared/components/StepProgressBar';

const steps = ['Patient Info', 'Specialty Questions', 'Select Provider', 'Confirmation'];

/** @type { StatelessComponent<{currentStep: 1 | 2 | 3 | 4}> } */
const ReferralStepIndicator = ({ currentStep }) => (
  <StepProgressBar currentStep={currentStep} stepLabels={steps} />
);

ReferralStepIndicator.displayName = 'ReferralStepIndicator';

ReferralStepIndicator.propTypes = {
  currentStep: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
};

export default ReferralStepIndicator;
